import {
  AddEditDocumentDialogParams,
  AddEditDocumentDialogResult,
} from '../add-edit-document-dialog/add-edit-document-dialog-models';

export class AconexImportDialogParams {
  public documentParams!: AddEditDocumentDialogParams;
  constructor(params?: Partial<AconexImportDialogParams>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AconexImportDialogResult {
  public didImport = false;
  public result: AddEditDocumentDialogResult | null = null;
  constructor(params?: Partial<AconexImportDialogResult>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AconexImportDialog {
  public open!: (params: AconexImportDialogParams) => Promise<AconexImportDialogResult>;
}
